import React, { Component } from 'react'
import { Container } from './elements'
import { connect } from 'react-redux'
import { setupIframeMessageListener } from 'app/utils/iframe-communication'

class AppPage extends Component {
  cleanupListener = null

  componentDidMount() {
    this.cleanupListener = setupIframeMessageListener()
  }

  componentWillUnmount() {
    if (this.cleanupListener) {
      this.cleanupListener()
    }
  }

  render() {
    return <Container>{this.props.children}</Container>
  }
}

export default connect()(AppPage)
